
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.158 8.095l4.4 3.342 1.713-2.252-3.448-2.62L13.43 4.45l3.447 2.62 2.887-3.8a11.664 11.664 0 00-18 14.56l7.394-9.736z","fill":"#00B2FF"}}),_c('path',{attrs:{"d":"M21.57 5.507l-7.4 9.739-4.4-3.343-1.713 2.252 3.447 2.62-1.607 2.114-3.447-2.62-2.887 3.8a11.664 11.664 0 0018-14.56l.007-.002z","fill":"#22E8B3"}})])
          )
        }
      }
    